(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sub-box-order-summary"] && !Shopify.designMode) return;
  try {
    
  class SubscriptionBoxOrderSummary extends HTMLElement {
    constructor() {
        super();

        this.querySelector(".add-sub-box").addEventListener("click", this.buildSubBox.bind(this));
    }

    buildSubBox(event) {
        event.preventDefault();
        event.stopImmediatePropagation();
        event.target.classList.add("disabled");
        event.target.innerText = "Adding...";
        document.querySelector("body").classList.add("subscription-box-creating");
        
        const items = [{
            id: window.subBoxId,
            quantity: 1,
            selling_plan: window.subBoxSchedule.id
        }];

        window.cartObject['items'].forEach(function(item) {
            items.push({
                id: item.id,
                quantity: item.quantity
            })
        });
        fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                'items': items
            })
        })
        .then(response => {
            return response.json();
        })
        .then(cart => {
            window.location.replace("/cart");
        })
        .catch((error) => {
            console.error('Error:', error);
        });
        
    }
  }
  customElements.define('sub-box-order-summary', SubscriptionBoxOrderSummary);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sub-box-schedule-selection"] && !Shopify.designMode) return;
  try {
    
  class SubscriptionBoxSchedules extends HTMLElement {
    constructor() {
        super();

        const scheduleItems = this.querySelectorAll(".sub-box-schedules li");
        this.selectSchedule(scheduleItems);
    }

    selectSchedule(scheduleItems) {
        scheduleItems.forEach(function(item) {
            item.querySelector(".select-schedule").addEventListener("click", function() {
                event.preventDefault();
                event.stopImmediatePropagation();

                scheduleItems.forEach(function(el) {
                    el.querySelector(".select-schedule").textContent = "Select";
                    el.querySelector(".checkmark").classList.remove("checked");
                });
                item.querySelector(".select-schedule").textContent = "Selected";
                item.querySelector(".checkmark").classList.add("checked");

                window.subBoxSchedule = {
                    'id': item.dataset.id,
                    'schedule': item.dataset.name
                };

                document.querySelector(".sub-box-summary--section").classList.add("show");

                // build box items html

                const boxItemsHTML = `
                    ${window.cartObject['items'].map(function(item) {
                        return `<p>${item.title} - ${item.quantity}</p>`;
                    }).join("")}
                `;

                const scheduleHTML = `<p>Delivery: ${window.subBoxSchedule.schedule}</p>`;

                document.querySelector(".sub-box-order-summary--items").insertAdjacentHTML("beforeend", boxItemsHTML);
                document.querySelector(".sub-box-order-summary--info").insertAdjacentHTML("afterbegin", scheduleHTML);

                document.querySelector(".sub-box-summary--section").classList.add("show");
            });
        });

    }
  }
  customElements.define('sub-box-schedules', SubscriptionBoxSchedules);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sub-box-size-selection"] && !Shopify.designMode) return;
  try {
    
  class SubscriptionBoxSizes extends HTMLElement {
    constructor() {
        super();

        const sizeItems = this.querySelectorAll(".sub-box-sizes li");
        this.selectSize(sizeItems);
    }

    selectSize(sizeItems) {
        sizeItems.forEach(function(item) {
            item.querySelector(".select-size").addEventListener("click", function() {
                event.preventDefault();
                event.stopImmediatePropagation();

                window.subBoxPrice = parseInt(item.dataset.price);
                window.subBoxId = item.dataset.id;

                sizeItems.forEach(function(el) {
                    el.querySelector(".select-size").textContent = "Select";
                    el.querySelector(".checkmark").classList.remove("checked");
                });
                item.querySelector(".select-size").textContent = "Selected";
                item.querySelector(".checkmark").classList.add("checked");

                document.querySelector(".sub-box-price").innerText = window.subBoxPrice;
                document.querySelector(".sub-box-progress-bar-wrapper").style.setProperty("--barWidth", `${window.subBoxPrice}%`);
                document.querySelector(".sub-box-products-section").classList.add("show");

                // reset everything

                window.cartObject = {
                    'items': []
                }
                document.querySelectorAll(".product-card-wrapper").forEach(function(card) {
                    card.querySelector(".quantity__input").value = 0;
                });
                document.querySelector(".goto-schedule").classList.remove("show");
                document.querySelector(".sub-box-schedule-section").classList.remove("show");
                document.querySelector(".sub-box-summary--section").classList.remove("show");

                document.querySelector(".sub-box-order-summary--total").innerText = window.subBoxPrice;

                document.querySelector(".sub-box-order-summary--items").innerHTML = "";
                const BoxHTML = `
                    <p>Build Your Field Box - ${item.querySelector("h3").innerText}</p>
                `;
                document.querySelector(".sub-box-order-summary--items").insertAdjacentHTML("beforeend", BoxHTML);
            });
        });

    }
  }
  customElements.define('sub-box-sizes', SubscriptionBoxSizes);

  } catch(e) { console.error(e); }
})();
})();
